module.exports = __webpack_public_path__ + "img/ps4-controller-default.65ae3a10.png";